import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

export const Container = styled.div`
  margin: auto;
  background-color: #F7F7F7;
  box-shadow: 0px 2px 10px -6px #252525;
  max-width: 400px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center !important;
  padding: 5px;
  margin-top: 70px;
`

export const Form = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F7F7F7;
  padding: 10px;
`

export const Image = styled.img`
  margin-bottom: 10px;
`

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 10px;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin-top: 10px;
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  padding: 0px;
`

export const WarningText = styled.p`
  margin: 2px 0px 0px;
  color: #FF3939;
  text-align: center;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-top: 15px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`
